/**
 * YAML Minify Tool
 *
 * Minify YAML by converting to compact flow style (minimal whitespace).
 */

import { parse as parseYaml, stringify as stringifyYaml } from 'yaml';

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import { ToolError } from '@/engine/errors/ToolError';
import type { ITransformerTool } from '@/interfaces/ITool';

export const YamlMinifyTool: ITransformerTool = {
  id: 'yaml-minify',
  name: 'YAML Minify',
  description: 'Minify YAML using compact flow style with minimal whitespace',
  version: '1.0.0',
  type: 'transformer',
  category: 'Formatters & Minifiers',
  keywords: ['yaml', 'minify', 'compress', 'compact', 'flow'],

  seo: {
    slug: 'yaml-minifier',
    pageTitle: 'YAML Minifier - Free Online Tool | SWE DevTools',
    metaDescription: 'Minify YAML to compact flow style with minimal whitespace. Reduce YAML file size instantly. Fast, private, runs entirely in your browser.',
    keywords: ['yaml minifier', 'minify yaml online', 'yaml compress', 'yaml compact', 'yaml flow style'],
    relatedTools: ['yaml-format', 'yaml-validate', 'yaml-to-json'],
    schemaType: 'WebApplication',
  },

  supportedInputTypes: [SEMANTIC_TYPES.YAML, SEMANTIC_TYPES.TEXT],
  outputType: SEMANTIC_TYPES.YAML,

  attributes: [],

  async transform(input: string): Promise<string> {
    const text = String(input ?? '').trim();
    if (!text) return '';

    try {
      const parsed = parseYaml(text);
      return stringifyYaml(parsed, { collectionStyle: 'flow' }).trimEnd();
    } catch (e) {
      const message = e instanceof Error ? e.message : 'Failed to minify YAML';
      throw ToolError.execution(message);
    }
  },
};
